'use client';

import { runningClientSide } from '@benzinga/utils';

export const useWindowLocationParams = () => {
  const queryParams: URLSearchParams | null = runningClientSide()
    ? new URLSearchParams(window?.location?.search)
    : null;

  const updateQueryParams = (queryParams: URLSearchParams & { size: number }): void => {
    let path = window.location.origin + window.location.pathname;

    if (queryParams?.size) {
      path += `?${queryParams.toString()}`;
    }

    window?.history?.replaceState({}, '', path);
  };

  return {
    queryParams,
    updateQueryParams,
  };
};

export default useWindowLocationParams;
